module.exports = __webpack_public_path__ + "static/media/people_white_24dp.4f54da97.svg";